<template>
  <div class="menu-item" id="lang-selector" v-on:mouseover="isOpen = true" v-on:mouseleave="isOpen = false">
    <span class="title" :active="isOpen">
      {{ $i18n.locale }}
    </span>
    <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.66428 7L12.2822 0.999998" :stroke="isOpen ? '#FFED00' : '#ffffff'" stroke-linecap="square" />
      <path d="M0.999728 0.999997L6.61768 7" :stroke="isOpen ? '#FFED00' : '#ffffff'" stroke-linecap="square" />
    </svg>
    <transition name="fade" apear>
      <div class="sub-menu" v-if="isOpen">
        <span v-for="oLang in languages">
          <router-link v-if="(oLang != $i18n.locale) && idParam"
            :to="{ name: $route.name, params: { lang: oLang, id: messages[oLang]['productos']['nav_options'][idParam]['id'] } }">
            <img v-if="oLang != $i18n.locale" :src="`/static/img/flag-${oLang}.svg`" class="">
            {{ oLang }}
          </router-link>
          <router-link v-else-if="oLang != $i18n.locale" :to="{ name: $route.name, params: { lang: oLang } }">
            <img v-if="oLang != $i18n.locale" :src="`/static/img/flag-${oLang}.svg`" class="">
            {{ oLang }}
          </router-link>
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
import messages from '@/translations';
import { mapActions } from 'vuex'

export default {
  name: 'lang-selector',
  created() {
    if(this.$route.params.id){
      let id = this.$t(`productos.keys.${this.$route.params.id}`)

      if(id.includes('productos') === false){
        this.idParam = this.$t(`productos.keys.${this.$route.params.id}`)
      }

    }
  },
  data() {
    let idParam = null;
    return {
      languages: Object.keys(messages),
      isOpen: true,
      messages,
      idParam
    }
  },
  methods: {
    ...mapActions({
      fetchTips: 'fetchTips'
    })
  },
  watch: {
    "$route.params.id"() {
      if (this.$route.params.id) {
        let id = this.$t(`productos.keys.${this.$route.params.id}`)

        if(id.includes('productos') === false){
          this.idParam = this.$t(`productos.keys.${this.$route.params.id}`)
        }

      }else {
        this.idParam = null;
      }
    },
    "$route.params.lang"() {
      if (this.$route.params.lang) {
        this.fetchTips(this.$route.params.lang)
      }
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/parts/lang-selector.vue